<template>
  <div class="report-wrap" v-loading="loading">
    <div class="top-wrap clear">
      <div class="options-wrap fl">
        <el-radio-group v-model="date_type" @change="changeDateType">
          <el-radio-button label="月报表"></el-radio-button>
          <el-radio-button label="年报表"></el-radio-button>
        </el-radio-group>
      </div>
      <el-button class="fr" @click="download">下载</el-button>
      <el-button class="fr" @click="printTable">打印</el-button>
    </div>
    <div class="con-wrap">
      <corner-box class="left-wrap box-element">
        <p>
          报表类型：
          <span>{{ report_type }}</span>
        </p>
        <!-- <span class="name">商户/表:</span> -->
        <!-- <el-select v-model="user">
          <el-option v-for="item in user_list" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select> -->
        <div>商业用电：</div>
        <el-tree :data="categoryList" node-key="id" ref="tree" :props="defaultProps"
          :default-checked-keys="defaultCheckedTreeKey" :default-expanded-keys="defaultCheckedTreeKey" show-checkbox>
        </el-tree>
      </corner-box>
      <corner-box class="right-wrap box-element">
        <div class="query-item clear">
          <!-- <div class="options-wrap">
            <el-radio-group v-model="date_type" @change="changeDateType">
              <el-radio-button label="月报表"></el-radio-button>
              <el-radio-button label="年报表"></el-radio-button>
            </el-radio-group>
          </div> -->
          <div class="query-box">
            选择日期：
            <el-date-picker v-model="date_picker.start_date" :type="date_picker.type" :format="format"
              :value-format="format" :picker-options="defaultSdate" :key="'start' + date_picker.start_date"
              :clearable='false'></el-date-picker>
            <span v-if="date_picker.isShow"> — </span>
            <el-date-picker v-model="date_picker.end_date" :type="date_picker.type" :format="format"
              :value-format="format" :picker-options="defaultEdate" :key="'end' + date_picker.end_date"
              :clearable='false'></el-date-picker>
            <span class="name">报表类型:</span>
            <el-select v-model="category" class="category">
              <el-option v-for="item in category_list" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
            <el-button @click="queryTable">查询</el-button>
            <el-button @click="checkOpen">分时电价收费标准</el-button>
            <!-- <span class="name">费率：元/kW·h</span>
            <span class="name">峰段：1.1902</span>
            <span class="name">平段：1.1902</span>
            <span class="name">谷段：1.1902</span> -->
          </div>
        </div>
        <div class="table-wrap" id="table-print">
          <table id="tableA" v-if="showTable">
            <tr v-for="(item, row) in table_data" :key="row">
              <td v-for="(content, col) in item" :id="'tb__' + row + '_' + col" :key="col">{{ content }}</td>
            </tr>
          </table>
        </div>

      </corner-box>
    </div>
    <el-dialog title="分时电价收费标准" :visible.sync="checkVisible" width="70%">
      <el-table :data="check_data" border>
        <el-table-column prop="month" label="日期(月)" width="150">
        </el-table-column>
        <el-table-column label="尖峰">
          <el-table-column label="时段（时）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingConfiguration).top ?
                  JSON.parse(scope.row.timeSharingConfiguration).top.join(',') : '-——'
              }}
            </template>
          </el-table-column>
          <el-table-column label="电费（元）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingElectricCharge).top ?
                  JSON.parse(scope.row.timeSharingElectricCharge).top : '——'
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="高峰">
          <el-table-column label="时段（时）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingConfiguration).peak.join(',') }}
            </template>
          </el-table-column>
          <el-table-column label="电费（元）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingElectricCharge).peak }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="平段">
          <el-table-column label="时段（时）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingConfiguration).plain.join(',') }}
            </template>
          </el-table-column>
          <el-table-column label="电费（元）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingElectricCharge).plain }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="谷段">
          <el-table-column label="时段（时）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingConfiguration).valley.join(',') }}
            </template>
          </el-table-column>
          <el-table-column label="电费（元）">
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.timeSharingElectricCharge).valley }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cornerBox from "../../components/cornerBox";
import { getNowFormatDate, getLastDay, getSession, setSession, formatDate } from "../../assets/js/tools/instruments";

export default {
  name: "electricityReport",
  components: {
    cornerBox
  },
  data() {
    return {
      // user: '',
      // user_list: [

      // ],
      category: '',
      category_list: [
      ],
      showTable: true,
      loading: false,
      isHour: true,
      date_type: '月报表',
      divisionId: 1,
      arrs: [],
      categoryTypeList: '',
      divisionList: [],
      report_type: '商户用电',
      report_type_id: 1,
      categoryList: [],
      defaultCheckedTreeKey: [],
      category_ids: '',
      dateType: 'month',
      date_picker: {
        isShow: true,
        start_date: getNowFormatDate(),
        end_date: '',
        type: 'month',
      },
      format: 'yyyy-MM',
      defaultSdate: {
        disabledDate: (time) => {
          return time.getTime() >= new Date(this.date_picker.end_date).getTime() || time.getTime() < new Date(JSON.parse(getSession("projectInfo")).projectStartTime).getTime()
        }
      },
      defaultEdate: {
        disabledDate: (time) => {
          return time.getTime() <= new Date(this.date_picker.start_date).getTime() || time.getTime() > new Date().getTime()
        }
      },
      defaultProps: {
        children: "child",
        label: "categoryName"
      },
      spanFirstArr: [],
      spanSecondArr: [],
      pos: '',
      table_list: [],
      rowspan: '',
      table_data: [],
      table_head: [],
      checkVisible: false,
      check_data: [],
    }
  },
  created() {

  },
  mounted() {
    // this.initDivisionList();
    this.ininElecCategoryList();
    this.date_picker.start_date = getLastDay('month', 'month');
    this.date_picker.end_date = getNowFormatDate('month');


  },
  methods: {
    uniTable(tableId, colLength) {
      var tb = document.getElementById(tableId)
      var i = 0;
      var j = 0;
      var rowCount = tb.rows.length; //   行数
      var colCount = tb.rows[0].cells.length; //   列数
      var obj1 = null;
      var obj2 = null;
      for (i = 0; i < colCount; i++) {
        if (i == colLength) break;
        obj1 = document.getElementById("tb__0_" + i)
        for (j = 1; j < rowCount; j++) {
          obj2 = document.getElementById("tb__" + j + "_" + i);
          if (obj1.innerText == obj2.innerText && (obj1.innerText != '' && obj2.innerText != '')) {
            obj2.parentNode.removeChild(obj2);
            obj1.rowSpan++;
          } else {
            obj1 = document.getElementById("tb__" + j + "_" + i);
          }
        }
      }
    },
    getTree() {
      var arr = [];
      for (let i in this.$refs.tree.getCheckedNodes()) {
        arr.push(this.$refs.tree.getCheckedNodes()[i].id)
      }
      this.category_ids = arr.toString();
      console.log(this.category_ids)
    },
    //获取今天日期格式
    getTime(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var year = date.getFullYear();
      var M = month < 10 ? '0' + month : month;
      var D = day + 1 < 10 ? '0' + day - 1 : day - 1;
      return year + '-' + M + '-' + D
    },
    //获取当前月格式
    getMonth(date) {
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      var M = month < 10 ? '0' + month : month;
      return year + '-' + M
    },
    changeDateType(value) {
      this.date_picker.start_date = '';
      this.date_picker.end_date = '';
      if (value == '月报表') {
        this.format = "yyyy-MM";
        this.date_picker.start_date = getLastDay('month', 'month');
        this.date_picker.end_date = getNowFormatDate('month');
        this.date_picker.isShow = true;
        this.date_picker.type = "month";
        this.dateType = 'month'
        this.queryTable()
      } else if (value == '年报表') {
        let projectStartTime = JSON.parse(getSession('projectInfo')).projectStartTime;
        this.date_picker.start_date = formatDate(new Date(projectStartTime), 'year').toString();
        this.date_picker.end_date = getNowFormatDate('year').toString();
        this.date_picker.isShow = true;
        this.format = "yyyy";
        this.date_picker.type = "year";
        this.dateType = 'year'
        this.queryTable()
      }

    },
    initDivisionList() {
      this.$get('electricityreport/divisionlist').then((response) => {
        this.divisionList = response;
        this.divisionId = response[0].id;
      })
    },
    ininElecCategoryList() {
      let $this = this
      // this.$get('electricityreport/eleccategorylist',
      //   [this.report_type_id]
      // ).then((response) => {
      //   this.categoryTypeList = response.categoryTypeList;
      //   this.categoryList = response.categoryList;
      //   this.defaultCheckedTreeKey = this.getTreeChild(response.categoryList);
      //   setTimeout(function () {
      //     $this.queryTable();
      //   }, 0)
      // })
      this.$get('customerelectricityreport/getbuserlist'
      ).then((response) => {
        this.check_data = response.elecCostConfig
        this.check_data.forEach(e => {
          e.month = e.month.replace(/\[|]/g, '')
        })
        // this.categoryTypeList = response.categoryTypeList;
        this.categoryList = response.tree;
        this.defaultCheckedTreeKey = this.getTreeChild(response.tree);
        this.category_list = response.reportTypes
        this.category = response.reportTypes[0].id
        this.user_list = response.period
        this.user = response.period[0].id
        setTimeout(function () {
          $this.queryTable();
        }, 0)
      })
    },
    getTreeChild(data) {
      let result = [];
      let rr = function (arr) {
        arr.forEach(function (item) {
          result.push(item.id);
          if (item.child && item.child.length > 0) {
            rr(item.child)
          }
        })
      }
      rr(data)
      return result
    },
    queryTable() {
      this.showTable = false;
      this.loading = true;
      let $this = this
      this.getTree();
      let array = [];
      array = [this.category, this.category_ids, this.dateType, this.date_picker.start_date, this.date_picker.end_date]
      if (this.category_ids == '') {
        this.$message.warning('请选择商户')
        this.loading = false
        return
      }
      this.$get('customerelectricityreport/getbuserelecreportdata', array
      ).then((response) => {
        console.log(response)
        this.showTable = true
        this.table_data = response.tableData;
        this.table_data.unshift(response.columnList);
        setTimeout(function () {
          $this.uniTable('tableA', 2);
        }, 50)
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })

    },
    download() {
      let array = [];
      array = [this.category, this.category_ids, this.dateType, this.date_picker.start_date, this.date_picker.end_date]
      let a = document.createElement('a');
      a.setAttribute('href', this.rootUrl + 'customerelectricityreport/downloadbuserelecreportdata/' + array.join('/'));
      a.setAttribute('download', '');
      a.click();
      a.remove();
    },
    checkOpen() {
      this.checkVisible = true
    },
    printTable() {
      let routeData = this.$router.resolve({
        path: '/customerElectricityReportPrint',
        name: 'customerElectricityReportPrint',
      });
      localStorage.setItem("category", this.category)
      localStorage.setItem("categoryIds", this.category_ids)
      localStorage.setItem("dateType", this.dateType)
      localStorage.setItem("startData", this.date_picker.start_date)
      localStorage.setItem("endData", this.date_picker.end_date)
      window.open(routeData.href, "_blank")

    }
  }
}
</script>

<style scoped lang="scss">
.report-wrap {
  .top-wrap {
    width: 100%;
    padding-top: 15px;
    padding-left: 10px;
    padding-right: 10px;

    /*background: $theme;*/
    .el-button {
      margin-left: 10px;
    }
  }

  .con-wrap {
    padding-left: 10px;
    margin-top: 10px;
    display: flex;
    .left-wrap {
      width: 280px;
      height: 705px;
      color: #ffffff;
      font-size: 14px;
      margin-right: 10px;
      padding: 15px 10px 10px;

      .el-tree {
        width: 270px;
        height: 567px;
        overflow: auto;
      }

      .name {
        margin-right: 0px;
      }

      div {
        margin-top: 10px;
      }

      span {
        color: #7bf8fa;
      }
    }

    .right-wrap {

      width: 100%;
      height: 705px;

      .query-item {
        padding-top: 10px;
        padding-left: 10px;
        color: #ffffff;
        margin-bottom: 10px;

        .options-wrap {
          float: left;
        }

        .query-box {
          float: left;
          margin-left: 10px;

          .name {
            margin-left: 10px;
          }

          .category {
            margin-left: 10px;
          }

          .el-button {
            margin-left: 20px;
          }
        }
      }

      .table-wrap {
        padding: 10px;
        height: 650px;
        overflow-x: auto;
        // max-width: 1380px;

        table {
          width: 100%;
          // height: 520px;
          border: #1384c5 1px solid;
          border-collapse: collapse;
          color: #fff;
          overflow-x: hidden;
          table-layout: fixed;
          word-break: break-all;
          word-wrap: break-word;

          tr {
            td {
              border: #1384c5 1px solid;
              width: 80px;
              height: 36px;
              text-align: center;
            }

            &:first-child {
              height: 50px;
              background-color: #409eff;
            }
          }
        }
      }
    }
  }
}
</style>
